<template>
    <rkm-overlay>
        <rkm-layout-body title="Parametrização">
            <template v-slot:actions>
                <rkm-button
                    v-if="showSaveButton"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :key="key"
                    @destroyed="destroyed"
                    @loaded="loaded"
                    @saved="saved"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/integracao/ria/parametrizacao/Form'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Form},
    created() {
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        key: 1,
        showSaveButton: false,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        loaded(showSaveButton) {
            this.showSaveButton = showSaveButton
        },
        saved() {
            this.key = this.key + 1
            this.unsetShowExitFormConfirmation()
        },
        destroyed() {
            this.key = this.key + 1
            this.unsetShowExitFormConfirmation()
        },
    },
}
</script>